import { styled } from '@mui/system';

export const InputParametersContainer = styled('div')(({ theme }) => ({
	width: '100%',
	display: 'flex',
	flexWrap: 'wrap',
	justifyContent: 'space-between'
}));

export const InputContainer = styled('div')(({ theme }) => ({
	flex: '0 0 45%',
	marginBottom: theme.spacing(3)
}));
